import { Question } from "../../interfaces/purchase-order.interface";

export class BillingChainQuestion {
  public static question_invoice_main_endorsement: Question[] = [
    {
      type: "automatic-radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y nítido.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "select",
      question: "¿Cuál de estas leyendas tiene la factura?",
      formatted_question: "¿Cuál de estas <b>leyendas</b> tiene la factura?",
      control: "text_invoice",
      options: [
        { label: "Nuevo", value: { value: "Nuevo", incident: false } },
        { label: "ISAN", value: { value: "ISAN", incident: false } },
        { label: "NOM 160", value: { value: "NOM 160", incident: false } },
        { label: "Demo", value: { value: "Demo", incident: false } },
        { label: "Asignación al activo fijo", value: { value: "Asignación al activo fijo", incident: false } },
        { label: "Carta resguardo", value: { value: "Carta resguardo", incident: false } },
        {
          label: "Condiciones del auto",
          value: {
            value: "Condiciones del auto",
            incident: true,
            incident_text:
              "El documento debe tener alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
        {
          label: "NOM 122",
          value: {
            value: "NOM 122",
            incident: true,
            incident_text:
              "El documento debe tener alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
        {
          label: "Copia sin valor",
          value: {
            value: "Copia sin valor",
            incident: true,
            incident_text:
              "El documento debe tener alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-radio",
      question: "¿La factura tiene la leyenda Copia sin valor?",
      formatted_question: "¿La factura <b>tiene</b> la leyenda <b>Copia sin valor?</b>",
      control: "copy_invoice",
      options: [
        {
          label: "Sí, tiene la leyenda",
          value: {
            value: "si",
            incident: true,
            incident_text: 'En el documento no debe aparecer la leyenda "Copia sin valor".',
          },
        },
        { label: "No", value: { value: "no", incident: false } },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-textbox",
      question: "Folio fiscal capturado",
      control: "fiscal_code",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-radio-question-select",
      question_confirm: "¿Se pudo consultar la información en el portal del SAT?",
      answer_confirm: undefined,
      open_select: "yes",
      control: "info_sat",
      options: [
        { label: "Sí", value: { value: "yes", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "El documento debe ser legible: en tamaño carta y nítido, no se detectó información ni se pudo leer el código QR.",
          },
        },
      ],
      answer: undefined,
      label: "¿Qué medio usaste?",
      select_options: [
        { label: "Código QR", value: { value: "Código QR", incident: false } },
        { label: "Folio Fiscal", value: { value: "Folio Fiscal", incident: false } },
      ],
      edit: true,
      automatic_answer: undefined,
      edit_select: true,
      automatic_select_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-radio",
      question: "¿La factura está vigente ante el SAT?",
      control: "current_invoice",
      options: [
        { label: "Sí", value: { value: "Código QR", incident: false } },
        {
          label: "No",
          value: {
            value: "invoice valid",
            incident: true,
            incident_text:
              "El documento debe estar vigente ante el SAT, revisa con la agencia si existe otra factura y si en su momento fue reemplazada correctamente.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-radio",
      question: "¿Los datos del portal del SAT corresponden con los de la factura impresa?",
      control: "corresponding_data",
      options: [
        { label: "Sí", value: { value: "Código QR", incident: false } },
        {
          label: "No",
          value: {
            value: "Folio Fiscal",
            incident: true,
            incident_text: "Los datos impresos en la factura deben coincidir con lo que muestra el SAT.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Emisor",
      control: "emit_name_validation",
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Receptor",
      control: "receiver_name_validation",
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-textbox",
      question: "Monto de la factura",
      control: "invoice_amount_validation",
      currency: true,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-textbox",
      question: "Número de identificación vehicular (NIV)",
      control: "niv",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Modelo (Año)",
      control: "model",
      pattern: ".*[0-9]{4}.*",
      pattern_error: "Ingresa un año válido",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Clave vehicular",
      control: "key_vehicle",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Número de motor",
      control: "engine_number",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-radio",
      question: "¿La información del endoso es legible?",
      formatted_question: "¿La información del <b>endoso</b> es <b>legible?</b>",
      control: "readable_info_endorsement",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 4,
    },
    {
      type: "automatic-radio",
      question: "¿El escaneo del endoso está derecho?",
      formatted_question: "¿El escaneo del <b>endoso</b> está <b>derecho</b>?",
      control: "onside_scan_endorsement",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 4,
    },
    {
      type: "automatic-radio",
      question: "¿La firma y/o rúbrica del <b>endoso</b> coincide con el anterior dueño (quien cede derechos)?",
      control: "last_owner_signature",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Revisa el documento y anexa uno nuevo que sea consecutivo, correcto y esté completo.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 4,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Receptor <b>(endoso)</b>",
      control: "receiver_name",
      edit: true,
      automatic_answer: undefined,
      page: 4,
    },
  ];

  public static question_invoice_main_no_endorsement: Question[] = [
    {
      type: "automatic-radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "select",
      question: "¿Cuál de estas leyendas tiene la factura?",
      formatted_question: "¿Cuál de estas <b>leyendas</b> tiene la factura?",
      control: "text_invoice",
      options: [
        { label: "Nuevo", value: { value: "Nuevo", incident: false } },
        { label: "ISAN", value: { value: "ISAN", incident: false } },
        { label: "NOM 160", value: { value: "NOM 160", incident: false } },
        { label: "Demo", value: { value: "Demo", incident: false } },
        { label: "Asignación al activo fijo", value: { value: "Asignación al activo fijo", incident: false } },
        { label: "Carta resguardo", value: { value: "Carta resguardo", incident: false } },
        {
          label: "Condiciones del auto",
          value: {
            value: "Condiciones del auto",
            incident: true,
            incident_text:
              "El documento debe tener alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
        {
          label: "NOM 122",
          value: {
            value: "NOM 122",
            incident: true,
            incident_text:
              "El documento debe tener alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
        {
          label: "Copia sin valor",
          value: {
            value: "Copia sin valor",
            incident: true,
            incident_text:
              "El documento debe tener alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-radio",
      question: "¿La factura tiene la leyenda Copia sin valor?",
      formatted_question: "¿La factura <b>tiene</b> la leyenda <b>Copia sin valor?</b>",
      control: "copy_invoice",
      options: [
        {
          label: "Sí, tiene la leyenda",
          value: {
            value: "si",
            incident: true,
            incident_text: 'En el documento no debe aparecer la leyenda "Copia sin valor".',
          },
        },
        { label: "No", value: { value: "no", incident: false } },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-textbox",
      question: "Folio fiscal capturado",
      control: "fiscal_code",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-radio-question-select",
      question_confirm: "¿Se pudo consultar la información en el portal del SAT?",
      answer_confirm: undefined,
      open_select: "yes",
      control: "info_sat",
      options: [
        { label: "Sí", value: { value: "yes", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "El documento debe ser legible: en tamaño carta y con buena nitidez, no se detectó información ni se pudo leer el código QR.",
          },
        },
      ],
      answer: undefined,
      label: "¿Qué medio usaste?",
      select_options: [
        { label: "Código QR", value: { value: "Código QR", incident: false } },
        { label: "Folio Fiscal", value: { value: "Folio Fiscal", incident: false } },
      ],
      edit: true,
      automatic_answer: undefined,
      edit_select: true,
      automatic_select_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-radio",
      question: "¿La factura está vigente ante el SAT?",
      control: "current_invoice",
      options: [
        { label: "Sí", value: { value: "Código QR", incident: false } },
        {
          label: "No",
          value: {
            value: "invoice valid",
            incident: true,
            incident_text:
              "El documento debe estar vigente ante el SAT, revisa con la agencia si existe otra factura y si en su momento fue reemplazada correctamente.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-radio",
      question: "¿Los datos del portal del SAT corresponden con los de la factura impresa?",
      control: "corresponding_data",
      options: [
        { label: "Sí", value: { value: "Código QR", incident: false } },
        {
          label: "No",
          value: {
            value: "Folio Fiscal",
            incident: true,
            incident_text: "Los datos impresos en la factura deben coincidir con lo que muestra el SAT.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Emisor",
      control: "emit_name_validation",
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Receptor",
      control: "receiver_name_validation",
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-textbox",
      question: "Monto de la factura",
      control: "invoice_amount_validation",
      currency: true,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-textbox",
      question: "Número de identificación vehicular (NIV)",
      control: "niv",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Modelo (Año)",
      control: "model",
      pattern: ".*[0-9]{4}.*",
      pattern_error: "Ingresa un año válido",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Clave vehicular",
      control: "key_vehicle",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Número de motor",
      control: "engine_number",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
  ];

  public static question_invoice_secondary_endorsement: Question[] = [
    {
      type: "automatic-radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-checkbox",
      question: "Número de identificación vehicular (NIV)",
      control: "vehicle_identification",
      label: "",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-checkbox",
      question: "Clave vehicular",
      control: "vehicle_key",
      label: "",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-checkbox",
      question: "Número de Motor",
      control: "number_engine",
      label: "",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-checkbox",
      question: "Modelo (Año)",
      control: "vehicle_model",
      label: "",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-radio",
      question: "¿Los datos coinciden con los de la factura de origen?",
      control: "match_data_invoice",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Reemplaza el documento con uno que contenga los datos vehiculares como en la factura de origen.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-radio-question-select",
      question_confirm: "¿Se pudo consultar la información en el portal del SAT?",
      open_select: "yes",
      answer_confirm: undefined,
      control: "info_sat",
      options: [
        { label: "Sí", value: { value: "yes", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "El documento debe ser legible: en tamaño carta y con buena nitidez, no se detectó información ni se pudo leer el código QR.",
          },
        },
      ],
      answer: undefined,
      label: "¿Qué medio usaste?",
      select_options: [
        { label: "Código QR", value: { value: "Código QR", incident: false } },
        { label: "Folio Fiscal", value: { value: "Folio Fiscal", incident: false } },
      ],
      edit: true,
      automatic_answer: undefined,
      edit_select: true,
      automatic_select_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-radio",
      question: "¿La factura está vigente ante el SAT?",
      control: "invoice_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "El documento debe estar vigente ante el SAT, revisa con la agencia si existe otra factura y si en su momento fue reemplazada correctamente.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-radio",
      question: "¿Todos los datos del portal SAT corresponden con los de la factura impresa",
      control: "correct_invoice",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento donde los datos impresos en la factura coincidan con lo que muestra el SAT.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Emisor",
      control: "emit_name_validation",
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Receptor",
      control: "receiver_name_validation",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Monto de la factura",
      control: "invoice_amount_validation",
      currency: true,
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-radio",
      question: "¿La información del endoso es legible?",
      formatted_question: "¿La información del <b>endoso</b> es <b>legible?</b>",
      control: "readable_info_endorsement",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 4,
    },
    {
      type: "automatic-radio",
      question: "¿El escaneo del endoso está derecho?",
      formatted_question: "¿El escaneo del <b>endoso</b> está <b>derecho</b>?",
      control: "onside_scan_endorsement",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 4,
    },
    {
      type: "automatic-radio",
      question: "¿La firma y/o rúbrica del <b>endoso</b> coincide con el anterior dueño (quien cede derechos)?",
      control: "last_owner_signature",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Revisa el documento y anexa uno nuevo que sea consecutivo, correcto y esté completo.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 4,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Receptor <b>(endoso)</b>",
      control: "receiver_name",
      edit: true,
      automatic_answer: undefined,
      page: 4,
    },
  ];

  public static question_invoice_secondary_no_endorsement: Question[] = [
    {
      type: "automatic-radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 1,
    },
    {
      type: "automatic-checkbox",
      question: "Número de identificación vehicular (NIV)",
      control: "vehicle_identification",
      label: "",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-checkbox",
      question: "Clave vehicular",
      control: "vehicle_key",
      label: "",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-checkbox",
      question: "Número de Motor",
      control: "number_engine",
      label: "",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-checkbox",
      question: "Modelo (Año)",
      control: "vehicle_model",
      label: "",
      answer: undefined,
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-radio",
      question: "¿Los datos coinciden con los de la factura de origen?",
      control: "match_data_invoice",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Reemplaza el documento con uno que contenga los datos vehiculares como en la factura de origen.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 2,
    },
    {
      type: "automatic-radio-question-select",
      question_confirm: "¿Se pudo consultar la información en el portal del SAT?",
      answer_confirm: undefined,
      open_select: "yes",
      control: "info_sat",
      options: [
        { label: "Sí", value: { value: "yes", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "El documento debe ser legible: en tamaño carta y con buena nitidez, no se detectó informacion ni se pudo leer el código QR.",
          },
        },
      ],
      answer: undefined,
      label: "¿Qué medio usaste?",
      select_options: [
        { label: "Código QR", value: { value: "Código QR", incident: false } },
        { label: "Folio Fiscal", value: { value: "Folio Fiscal", incident: false } },
      ],
      edit: true,
      automatic_answer: undefined,
      edit_select: true,
      automatic_select_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-radio",
      question: "¿La factura está vigente ante el SAT?",
      control: "invoice_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "El documento debe estar vigente ante el SAT, revisa con la agencia si existe otra factura y si en su momento fue reemplazada correctamente.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-radio",
      question: "¿Todos los datos del portal SAT corresponden con los de la factura impresa",
      control: "correct_invoice",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento donde los datos impresos en la factura coincidan con lo que muestra el SAT.",
          },
        },
      ],
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Emisor",
      control: "emit_name_validation",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Nombre del Receptor",
      control: "receiver_name_validation",
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
    {
      type: "automatic-textbox",
      question: "Monto de la factura",
      control: "invoice_amount_validation",
      currency: true,
      edit: true,
      automatic_answer: undefined,
      page: 3,
    },
  ];
}
